<template>
    <div class="reports">
        <div class="content-layout" v-if="$store.state.match">
            <div class="column column__small">
                <div class="block">
                    <div class="title">
                        Synsrapporter
                    </div>
                    <div class="body" v-if="$store.state.showingResult && !$store.state.loadingInspection && $store.state.carData.inspection !== null">
                        <div class="report-wrapper" v-if="$store.state.carData.inspection.Rapporter.length > 0">
                            <div class="mobile-helper">
                                Vælg en synsrapport og scroll ned for at læse detaljerne
                                <br><br>
                            </div>
                            <div class="single-report" v-for="(report, index) in sortedReports" @click="activeReport = index" :class="{'active': activeReport === index, 'good': report.Synsresultat === 'Godkendt', 'neutral': report.Synsresultat !== 'Godkendt'}">
                                <div class="date">
                                    {{ report.SynsdatoFormateret | moment('DD. MMM. YYYY') }}
                                </div>
                                <div class="result good" v-if="report.Synsresultat === 'Godkendt'">
                                    Godkendt
                                </div>
                                <div class="result neutral" v-else-if="report.Synsresultat === 'Middel'">
                                    Middel
                                </div>
                                <div class="result neutral" v-else-if="report.Synsresultat === 'Betinget godkendt'">
                                    Betinget godkendt
                                </div>
                                <div class="result neutral" v-else>
                                    Kan godk. efter omsyn
                                </div>
                            </div>
                        </div>
                        <div v-else>
                            Køretøjet har endnu ikke været synet.
                        </div>
                    </div>
                    <div class="body" v-else>
                        Ingen synsdata
                    </div>
                </div>
            </div>
            <div class="column column__large">
                <div class="block animated fadeIn" v-if="activeReport !== null && activeReport === index && $store.state.carData.inspection" v-for="(report, index) in sortedReports">
                    <div class="body">
                        <div class="active-report">
                            <div class="header">
                                <div class="result good" v-if="report.Synsresultat === 'Godkendt'">
                                    {{ report.Synsresultat }}
                                </div>
                                <div class="result neutral" v-else>
                                    {{ report.Synsresultat }}
                                </div>
                                <div class="company">
                                    <b>{{ report.Firma }}</b>
                                    <br>
                                    {{ report.Adresse }}
                                    <br>
                                    CVR: {{ report.Cvr }}        
                                </div>
                            </div>
                            <div class="boxes">
                                <div class="box">
                                    <div class="box__title">
                                        Synsdato
                                    </div>
                                    <div class="box__value">
                                        {{ report.SynsdatoFormateret | moment('D. MMMM YYYY') }}
                                    </div>
                                </div>
                                <div class="box">
                                    <div class="box__title">
                                        Synstype
                                    </div>
                                    <div class="box__value">
                                        {{ report.Synstype }}
                                    </div>
                                </div>
                                <div class="box">
                                    <div class="box__title">
                                        Nummerplade
                                    </div>
                                    <div class="box__value">
                                        {{ report.RegNr }}
                                    </div>
                                </div>
                                <div class="box">
                                    <div class="box__title">
                                        Kilometerstand
                                    </div>
                                    <div class="box__value">
                                        {{ report.Kmstand | thousand }} km
                                    </div>
                                </div>
                            </div>
                            <hr>
                            <div class="error-wrapper" v-if="report.Fejl">
                                <div class="error__title">
                                    Fejl ({{ report.Fejl.length }})
                                </div>
                                <div class="error-list" v-if="report.Fejl.length > 0">
                                    <div class="error" v-for="error in report.Fejl">
                                        <b>{{ error.Number }}</b> - {{ error.Description }}
                                    </div>
                                </div>
                                <div v-else>
                                    Ingen fejl registreret.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="block" v-if="activeReport === null">
                    <div class="body">
                        Vælg en synsrapport i menuen for at se hele rapportens detaljer her.
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
@import "../../../../styles/vars";

    .reports {

        .report-wrapper {

            .mobile-helper {
                display: none;

                @media screen and (max-width: $small) {
                    display: block;
                }
            }

            .single-report {
                display: flex;
                justify-content: space-between;
                padding: 10px;
                cursor: pointer;
                margin-bottom: 10px;
                background: rgba(0, 0, 0, 0.05);
                border-radius: 5px;

                @media screen and (max-width: $large) {
                    display: block;

                    .result {
                        display: inline-block;
                    }
                }

                &.active {
                    color: #fff;
                    font-weight: 600;

                    &.good {
                        background: $color--green;
                    }

                    &.neutral {
                        background: $color--orange;
                    }

                    .result {
                        background: #fff !important;
                        font-weight: normal;
                        
                        &.good {
                            color: $color--green !important;
                        }

                        &.neutral {
                            color: $color--orange !important;
                        }
                    }
                }

                &:hover:not(.active) {
                    background: rgba(0, 0, 0, 0.15);
                }

                .date {
                    white-space: nowrap;
                }

                .result {
                    font-size: 10px;
                    white-space: nowrap;
                    color: #fff;
                    padding: 2px 4px;
                    border-radius: 2px;
                    align-self: center;

                    &.good {
                        background: $color--green;
                    }

                    &.neutral {
                        background: $color--orange;
                    }
                }
            }
        }

        .active-report {
            
            .header {
                display: flex;
                justify-content: space-between;
                align-items: center;

                @media screen and (max-width: $small) {
                    display: block;
                    text-align: center;

                    .company {
                        margin-top: 30px;
                    }
                }

                .result {
                    font-size: 24px;
                    font-weight: 600;

                    &.good {
                        color: $color--green !important;
                    }

                    &.neutral {
                        color: $color--orange !important;
                    }
                }

                .company {
                    white-space: nowrap;
                }
            }

            .boxes {
                display: flex;
                justify-content: flex-start;
                margin: 60px 0;
                flex-wrap: wrap;

                @media screen and (max-width: $small) {
                    margin: 30px 0;
                }

                .box {
                    flex: 0 0 25%;
                    text-align: center;

                    @media screen and (max-width: $small) {
                        flex: 0 0 50%;

                        &:nth-of-type(1),
                        &:nth-of-type(2) {
                            margin-bottom: 15px;
                        }
                    }

                    &__title {
                        font-weight: 400;
                    }

                    &__value {
                        font-weight: 600;
                    }
                }
            }

            .error-wrapper {
                display: flex;

                @media screen and (max-width: $small) {
                    display: block;
                }

                .error__title {
                    white-space: nowrap;
                    padding-right: 50px;
                    font-size: 24px;

                    @media screen and (max-width: $small) {
                        padding: 0;
                        margin-bottom: 15px;
                    }
                }

                .error-list {
                    width: 100%;

                    .error {
                        padding: 15px;
                        border: 1px solid rgba(0, 0, 0, 0.15);
                        border-radius: 2px;
                        width: 100%;
                        // font-size: 12px;

                        b {
                            font-weight: 600;
                        }

                        &:not(:last-of-type) {
                            margin-bottom: 15px;
                        }
                    }
                }
            }
        }
    }

</style>


<script>
import moment from 'moment'

export default {
    data () {
        return {
            activeReport: null
        }
    },
    created () {
        if (this.$store.state.match && this.$store.state.carData.inspection && this.$store.state.carData.inspection.Rapporter.length > 0) {
            this.activeReport = 0
        }
    },
    computed: {
        sortedReports () {
            if (this.$store.state.match && this.$store.state.carData.inspection && this.$store.state.carData.inspection.Rapporter.length > 0) {
                this.$store.state.carData.inspection.Rapporter.forEach((report) => {
                    report.SynsdatoFormateret = moment(report.Synsdato, 'DD-MM-YYYY').format('YYYY-MM-DD[T]hh:mm')
                })
                return this.$store.state.carData.inspection.Rapporter
            } else {
                return false
            }
        }
    }
}
</script>




// WEBPACK FOOTER //
// reports.vue?6e4b314e